import systemPlanApi from '../../api/plan/systemPlanApi';
import type { ApiResponse } from '../../types/common/ApiResponse';
import type {
  Feature,
  SystemPlansDTO,
  UpdatePlanFeatureRequest,
} from '../../types/plans/Plans';

const SystemPlanService = {
  /**
   * Obtener todos los planes del sistema
   * GET /api/system/plans
   */
  fetchPlans: async (): Promise<ApiResponse<SystemPlansDTO>> => {
    const response = await systemPlanApi.fetchAll();
    return response.data;
  },

  /**
   * Cambiar plan activo
   * PUT /api/system/plans/{planCode}
   */
  changeActivePlan: async (planCode: string): Promise<ApiResponse<string>> => {
    const response = await systemPlanApi.modifyPathVariable(planCode);
    return response.data;
  },

  /** PATCH /api/system/plans/{planCode}/features/{featureCode} */
  updatePlanFeature: async (
    planCode: string,
    featureCode: string,
    payload: UpdatePlanFeatureRequest
  ): Promise<ApiResponse<Feature>> => {
    const response = await systemPlanApi.patchCustom(
      `${planCode}/features/${featureCode}`,
      payload
    );

    return response.data;
  },

  getPlanFeatures: async (
    planCode: string
  ): Promise<ApiResponse<Feature[]>> => {
    const response = await systemPlanApi.fetchCustom(`/${planCode}/features`);
    return response.data;
  },
};

export default SystemPlanService;
